<template>
  <label :class="['switch', { small, disabled }]">
    <input
        type="checkbox"
        :checked="value"
        @change="$emit('input', $event.target.checked)"
        :disabled="disabled"
    />
    <span class="slider"></span>
  </label>
</template>

<script>
export default {
  name: 'CustomSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch.small {
  width: 32px;
  height: 16px;
}
.switch.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Hide default checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-background-input);
  border: 2px solid #594434;
  border-radius: 24px;
  transition: 0.2s;
}
.switch.small .slider {
  border-radius: 16px;
}
.switch.disabled .slider {
  cursor: not-allowed;
}

/* The circle */
.slider::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: var(--color-background);
  border-radius: 50%;
  transition: 0.2s;
  transform: translateY(2px) translateX(-2px);
}
.switch.small .slider::before {
  height: 12px;
  width: 12px;
}

/* When checked */
.switch input:checked + .slider {
  background-color: var(--icon-green);
}
.switch input:checked + .slider::before {
  transform: translateX(20px) translateY(2px);
}

</style>
